<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>การเติมเงิน</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="orderList"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">
            <img src="../../assets/img/no-order.png" style="width: 30%" />
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <div style="width: 140px">
            <div
              v-if="item.status == 'void'"
              class="grey lighten-2 badge-status"
            >
              VOID
            </div>
            <div
              v-if="item.status == 'pending'"
              class="grey darken-2 badge-status"
            >
              <i class="far fa-clock"></i> รอชำระเงิน
            </div>

            <div v-else-if="item.status == 'waiting'" class="red badge-status">
              มาใหม่
            </div>
            <div
              v-if="item.status == 'accepted' || item.status == 'captured'"
              class="green darken-1 badge-status"
            >
              ยืนยันแล้ว
            </div>
            <div
              v-if="item.status == 'refected'"
              class="green lighten-1 badge-status"
            >
              ปฏิเสธแล้ว
            </div>
          </div>
        </template>

        <template v-slot:item.reference="{ item }">
          <div class="pt-3">
            <span class="black--text">{{ item.reference }}</span>
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <el-button type="text" size="small" @click="openItem(item)"
            >ดูรายละเอียด</el-button
          >
        </template>

        <template v-slot:item.user="{ item }">
          <!-- ข้อมูลลูกค้า -->
          <div style="width: 120px">
            <template v-if="item.user != null">
              <strong class="line-1-elipsis"
                >{{ item.user.firstname }} {{ item.user.lastname }}</strong
              >
              <div>
                <span class="font-xs grey--text">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user.mobile }}
                </span>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:item.amount="{ item }">
          <div @click="openPaymentInfo(item)">
            <strong>฿ {{ item.amount | numFormat("0,0.00") }}</strong>
            <br />

            <span
              class="font-xs grey--text"
              v-if="item.deposit_source == 'transfer'"
            >
              โอนเงิน
              <i
                v-if="item.payment.payment_image_url != null"
                @click="viewSlip(item.payment.payment_image_url)"
                class="far fa-file-image"
              ></i>
            </span>
            <span class="font-xs grey--text" v-if="item.payment_type == 'cash'"
              >ชำระเงินสด</span
            >
            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'creditcard'"
              >บัตรเครดิต</span
            >
          </div>
        </template>
      </v-data-table>

      <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div>
    </el-card>

    <deposit-dialog
      :showDialog="dialog"
      :data="selectedItem"
      @close="onDetailClosed()"
    ></deposit-dialog>
  </v-container>
</template>

<script>
import Service from "@/services";
import moment from "moment";
import { mapState } from "vuex";

import DepositDialog from "@/components/DepositDialog";
export default {
  components: {
    DepositDialog,
  },
  data() {
    return {
      mode: "admin",
      isLoading: true,
      dialog: false,
      orderList: [],
      selectedItem: null,
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      refresh: null,
      amount: {
        revenue: 0,
        delivery: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
      },
      tableHeight: "0px",
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "reference",
        },
        { text: "", value: "status", sortable: false },
        { text: "", value: "action", sortable: false },
        { text: "เวลา", value: "created_at", sortable: false },
        { text: "ข้อมูลลูกค้า", value: "user", sortable: false },
        { text: "จำนวนเงิน", value: "amount", sortable: false },
      ],
      statusOrdering: [
        "pending",
        "new",
        "acccepted",
        "delivering",
        "ready-to-go",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
      permission: null,
      paymentSlip: null,
      windowSize: null,
      paymentInfoDialog: false,
      selectedOrder: null,
    };
  },
  mounted() {
    this.onResize();
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;
    });
    this.date = moment().format("LLLL");

    this.loadOrder();
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      //console.log(this.windowSize);
      this.tableHeight = window.innerHeight + "px";
    },
    loadOrder() {
      this.isLoading = true;
      this.amount = {
        revenue: 0,
        delivery: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        discount: 0,
        completed: 0,
      };
      Service.Wallet.gets().then((res) => {
        this.isLoading = false;
        if (res.success) {
          this.orderList = res.data.rows;

          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );
        }
      });
    },
    openItem(item) {
      this.selectedItem = item;
      this.dialog = true;
    },
    onDetailClosed() {
      this.dialog = false;
      this.selectedItem = null;
      this.loadOrder();
    },
  },
  beforeRouteLeave(to, from, next) {
    //this.$store.dispatch("Auth/setWorkState", "working");
    clearInterval(this.refresh);
    next();
  },
};
</script>
<style>
tbody tr:nth-of-type(even) {
  background-color: rgb(241, 241, 241);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

.v-data-table-header {
  background-color: rgba(182, 183, 187);
  color: white;
}

.v-data-footer {
  background-color: rgb(250, 250, 250);
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
